module.exports = __webpack_public_path__ + "static/gv-94308d178e57f74a137595e0db380cc5.jpg";